import { z } from 'zod'

export enum FeatureFlag {
  Rules = 'rules',
  Registry = 'registry',
  Schemas = 'schemas',
  SDK = 'sdk',
  CLI = 'cli',
}

const featureSchema = z.boolean().optional()

export const featureFlagSchema = z.object({
  [FeatureFlag.Rules]: featureSchema,
  [FeatureFlag.Registry]: featureSchema,
  [FeatureFlag.Schemas]: featureSchema,
  [FeatureFlag.SDK]: featureSchema,
  [FeatureFlag.CLI]: featureSchema,
})
